<template>
<svg :width="width" :height="height" viewBox="0 0 16 22" :fill="color" xmlns="http://www.w3.org/2000/svg">
<path d="M8.0403 0L11.9628 2.2647V11.9706L8.0403 14.2353L4.1177 11.9706V2.2647L8.0403 0Z"  fill-opacity="0.3"/>
<path d="M1.5293 6.4707V13.5883L7.9999 17.4707L14.4705 13.5883V6.4707" stroke="#008FD1" stroke-opacity="0.3" stroke-:width="2.58823"/>
<path d="M11.8824 19.4116H4.1177V21.9998H11.8824V19.4116Z"  fill-opacity="0.3"/>
<path d="M9.29433 18.1177H6.7061V19.4118H9.29433V18.1177Z"  fill-opacity="0.3"/>
</svg>

</template>

<script>
export default {
    props: {
        width: { type: [Number, String], default: 16 },
        height: { type: [Number, String], default: 22 },
        color: { type: String, default: "#D3D4DE" }
    }
}
</script>
